import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { VehicleExpenseSearchResultsProps } from "./types";
import { useTranslate } from "helpers";
import VehicleExpenseRowChild from "../../../VehicleExpenseSearchPage/components/VehicleExpenseSearch/components/VehicleExpenseSearchResults/components/VehicleExpenseRowChild";
import {
  FLEET_VEHICLE_EXPENSE_SEARCH_COLUMNS,
  FLEET_VEHICLE_EXPENSE_UPLOADS_SEARCH_COLUMNS,
} from "../../../VehicleExpenseSearchPage/components/VehicleExpenseSearch/components/VehicleExpenseSearchResults/consts";

const VehicleSearchResults: React.FC<VehicleExpenseSearchResultsProps> = (
  props
) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onDeleteClick
  } = props;

  const { t } = useTranslate();

  return (
    <>
      <TableSearch
        columns={FLEET_VEHICLE_EXPENSE_SEARCH_COLUMNS(t, onDeleteClick)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        disablePagination={true}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
        columnsChild={FLEET_VEHICLE_EXPENSE_UPLOADS_SEARCH_COLUMNS(t)}
        CustomTableRowChild={(childProps) => (
          <VehicleExpenseRowChild
            {...childProps}
            onFetchSearchResult={() =>
              onPaginationChange?.(searchResults.pagination)
            }
          />
        )}
      />
    </>
  );
};
export default memo(VehicleSearchResults);
